export class MockedHemsFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: { entries: { type: 'array', value: [] } },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          ' /gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2023-03-23T11:39:14.269Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.control.vcs.0.charging.mode',
        gatewayId: gatewaySerial,
        feature: 'ems.control.vcs.0.charging.mode',
        timestamp: '2023-03-23T11:39:14.269Z',
        isEnabled: false,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: { value: { type: 'number', value: 0, unit: 'ampere' } },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/ems.grid.current.limit/commands/setValue',
            name: 'setValue',
            isExecutable: false,
            params: {
              value: {
                required: true,
                constraints: { min: 0, max: 250, stepping: 1 },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.grid.current.limit',
        gatewayId: gatewaySerial,
        feature: 'ems.grid.current.limit',
        timestamp: '2023-03-23T11:39:14.269Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          calculationStatus: { value: 'correct', type: 'string' },
          value: {
            value: [
              {
                ident: 1,
                parent: 1,
                type: 'TariffOne',
                class: 'Meter',
                value: -1902,
                unit: 'watt',
                children: [
                  {
                    ident: 2,
                    parent: 1,
                    type: 'Inverter',
                    class: 'Inverter',
                    value: -1902,
                    unit: 'watt',
                    children: [
                      {
                        ident: 3,
                        parent: 2,
                        type: 'Photovoltaic',
                        class: 'Producer',
                        value: -1503,
                        unit: 'watt',
                      },
                      {
                        ident: 6,
                        parent: 2,
                        type: 'Accumulator',
                        class: 'Storage',
                        value: -399,
                        unit: 'watt',
                      },
                    ],
                  },
                  {
                    ident: 4,
                    parent: 1,
                    type: 'Heatpump',
                    class: 'Consumer',
                    value: 0,
                    unit: 'watt',
                  },
                  {
                    ident: 5,
                    parent: 1,
                    type: 'Household',
                    class: 'Consumer',
                    value: 0,
                    unit: 'watt',
                  },
                ],
              },
            ],
            type: 'ElectricalEnergyMatrix',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.power.instantaneous',
        gatewayId: gatewaySerial,
        feature: 'ems.power.instantaneous',
        timestamp: '2023-03-24T10:35:48.869Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: { new: [], current: [], gone: [] },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/device.errors.active',
        gatewayId: gatewaySerial,
        feature: 'device.errors.active',
        timestamp: '2023-03-23T11:22:55.273Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.control.vcs.0.status',
        gatewayId: gatewaySerial,
        feature: 'ems.control.vcs.0.status',
        timestamp: '2023-03-23T11:39:14.269Z',
        isEnabled: false,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          value: {
            value: [
              {
                parent: 1,
                type: 'TariffOne',
                class: 'Meter',
                tariff1: { delivered: 5838.1, received: 623.4 },
                tariff2: { delivered: 0, received: 0 },
                unit: 'kilowattHour',
                ident: 1,
                children: [
                  {
                    parent: 1,
                    type: 'Inverter',
                    class: 'Inverter',
                    total: { delivered: 181.2, received: 26.5 },
                    unit: 'kilowattHour',
                    ident: 2,
                    children: [
                      {
                        parent: 2,
                        type: 'Photovoltaic',
                        class: 'Producer',
                        total: { delivered: 183.1, received: 0 },
                        unit: 'kilowattHour',
                        ident: 3,
                      },
                      {
                        parent: 2,
                        type: 'Accumulator',
                        class: 'Storage',
                        total: { delivered: 62, received: 67.6 },
                        unit: 'kilowattHour',
                        ident: 6,
                      },
                    ],
                  },
                  {
                    parent: 1,
                    type: 'Heatpump',
                    class: 'Consumer',
                    total: { delivered: 0, received: 272 },
                    unit: 'kilowattHour',
                    ident: 4,
                  },
                  {
                    parent: 1,
                    type: 'Household',
                    class: 'Consumer',
                    total: { delivered: null, received: null },
                    unit: 'kilowattHour',
                    ident: 5,
                  },
                ],
              },
            ],
            type: 'ElectricalEnergyMatrix',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.energy.instantaneous',
        gatewayId: gatewaySerial,
        feature: 'ems.energy.instantaneous',
        timestamp: '2023-03-24T10:35:07.876Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          calculationStatus: { type: 'string', value: 'correct' },
          received: {
            type: 'array',
            value: [
              { value: 0, unit: 'watt', type: 'Heatpump' },
              { value: 0, unit: 'watt', type: 'Household' },
              { type: 'Grid', unit: 'watt', value: 1902 },
            ],
          },
          delivered: {
            type: 'array',
            value: [
              { value: 1503, unit: 'watt', type: 'Photovoltaic' },
              { type: 'Accumulator', value: 399, unit: 'watt' },
            ],
          },
          totalConsumption: { type: 'number', value: 0, unit: '' },
          totalProduction: { type: 'number', value: 1503, unit: '' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.power.balance',
        gatewayId: gatewaySerial,
        feature: 'ems.power.balance',
        timestamp: '2023-03-24T10:35:48.836Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: { active: { value: true, type: 'boolean' } },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/ems.hoca.features.photovoltaicExcessToHeatpump/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/ems.hoca.features.photovoltaicExcessToHeatpump/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.hoca.features.photovoltaicExcessToHeatpump',
        gatewayId: gatewaySerial,
        feature: 'ems.hoca.features.photovoltaicExcessToHeatpump',
        timestamp: '2023-03-23T11:39:08.812Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          calculationStatus: { type: 'string', value: 'discarded' },
          autarky: { type: 'number', value: 0, unit: 'percent' },
          selfConsumption: { type: 'number', value: 0, unit: 'percent' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.kpi',
        gatewayId: gatewaySerial,
        feature: 'ems.kpi',
        timestamp: '2023-03-24T10:05:19.333Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.hoca.features.vcsOverloadProtection',
        gatewayId: gatewaySerial,
        feature: 'ems.hoca.features.vcsOverloadProtection',
        timestamp: '2023-03-23T11:39:08.812Z',
        isEnabled: false,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          activated: {
            type: 'array',
            value: [
              'photovoltaicExcessToHeatpump',
              'onlineSolarIrradianceForecast',
              'forecastBasedBatteryOperation',
            ],
          },
          supported: {
            type: 'array',
            value: [
              'photovoltaicExcessToHeatpump',
              'onlineSolarIrradianceForecast',
              'forecastBasedBatteryOperation',
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.hoca.features',
        gatewayId: gatewaySerial,
        feature: 'ems.hoca.features',
        timestamp: '2023-03-23T11:39:14.269Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: { active: { value: true, type: 'boolean' } },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/ems.hoca.features.onlineSolarIrradianceForecast/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/ems.hoca.features.onlineSolarIrradianceForecast/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.hoca.features.onlineSolarIrradianceForecast',
        gatewayId: gatewaySerial,
        feature: 'ems.hoca.features.onlineSolarIrradianceForecast',
        timestamp: '2023-03-23T11:39:08.812Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: { active: { value: true, type: 'boolean' } },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/ems.hoca.features.forecastBasedBatteryOperation/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/ems.hoca.features.forecastBasedBatteryOperation/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.hoca.features.forecastBasedBatteryOperation',
        gatewayId: gatewaySerial,
        feature: 'ems.hoca.features.forecastBasedBatteryOperation',
        timestamp: '2023-03-23T11:39:08.812Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          status: { type: 'string', value: 'ok' },
          productionToConsumption: { type: 'number', value: 0, unit: 'watt' },
          productionToStorage: { type: 'number', value: 0, unit: 'watt' },
          productionToGrid: { type: 'number', value: 1493, unit: 'watt' },
          gridToConsumption: { type: 'number', value: 0, unit: 'watt' },
          gridToStorage: { type: 'number', value: 0, unit: 'watt' },
          storageToConsumption: { type: 'number', value: 0, unit: 'watt' },
          storageToStorage: { type: 'number', value: 0, unit: 'watt' },
          storageToGrid: { type: 'number', value: 402, unit: 'watt' },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/ems.power.flows',
        gatewayId: gatewaySerial,
        feature: 'ems.power.flows',
        timestamp: '2023-03-24T10:35:48.836Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
      {
        properties: {
          value: {
            unit: 'watt/squareMeter',
            value: [
              190.1,
              181.084,
              181.084,
              181.084,
              181.084,
              122.216,
              122.216,
              122.216,
              122.216,
              524.642,
              524.642,
              524.642,
              524.642,
              578.77,
              578.77,
              578.77,
              578.77,
              494.3,
              494.3,
              494.3,
              494.3,
              360.93,
              360.93,
              360.93,
              360.93,
              207.32,
              207.32,
              207.32,
              207.32,
              58.1,
              58.1,
              58.1,
              58.1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              77.082,
              77.082,
              77.082,
              77.082,
              205.094,
              205.094,
              205.094,
              205.094,
              319.121,
              319.121,
              319.121,
              319.121,
              125.323,
              125.323,
              125.323,
              125.323,
              499.38,
              499.38,
              499.38,
              499.38,
              525.121,
              525.121,
              525.121,
              525.121,
              410.151,
              410.151,
              410.151,
              410.151,
              522.934,
              522.934,
              522.934,
              522.934,
              322.701,
              322.701,
              322.701,
              322.701,
              142.292,
              142.292,
              142.292,
              142.292,
              122.606,
              122.606,
              122.606,
              122.606,
              62.251,
              62.251,
              62.251,
              62.251,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              83.13,
              83.13,
              83.13,
              83.13,
              163.761,
              163.761,
              163.761,
              163.761,
              203.628,
              203.628,
              203.628,
              203.628,
              140.773,
              140.773,
              140.773,
            ],
            type: 'array',
          },
          forecastBeginning: { value: '2023-03-24T09:00:00.000Z', type: 'string' },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/HEMS/features/heating.solar.forecast.surfaceNetIrradiance/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                type: 'array',
                required: true,
                constraints: { minLength: 192, maxLength: 192 },
              },
              forecastBeginning: { type: 'string', required: true, constraints: {} },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/HEMS/features/heating.solar.forecast.surfaceNetIrradiance',
        gatewayId: gatewaySerial,
        feature: 'heating.solar.forecast.surfaceNetIrradiance',
        timestamp: '2023-03-24T09:01:24.663Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'HEMS',
      },
    ];
  }
}
